import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";

import { ReportSectionFieldsType } from "@api/graphql/types-and-hooks";
import { FieldCountBadge } from "@components/QaReview/components/FieldCountBadge";
import { useFieldReview } from "@components/QaReview/hooks/useFieldReview";
import { useGoToItem } from "@components/QaReview/hooks/useGoToItem";
import { useReviewAnchors } from "@components/QaReview/hooks/useReviewAnchors";
import { useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { useSidebarView } from "@providers/SidebarViewProvider/useSidebarView";

interface ReportFieldLabelSuggestionBadgeProps {
  field: ReportSectionFieldsType;
}

export const ReportFieldLabelSuggestionBadge: React.FC<ReportFieldLabelSuggestionBadgeProps> = ({ field }) => {
  const { countForField, firstOpenQaItemForField } = useReviewAnchors();
  const { isActive } = useFieldReview();
  const { setView } = useSidebarView();
  const goToItem = useGoToItem();
  const isReviewPage = useIsReviewPage();

  const suggestionCount = countForField(field.id);

  if (!suggestionCount || !isReviewPage) return null;

  const showSuggestions = () => {
    setView("review");
    const firstSuggestion = firstOpenQaItemForField(field.id);
    if (firstSuggestion) goToItem(firstSuggestion);
  };

  return (
    <FieldCountBadge
      count={suggestionCount}
      label={`${suggestionCount} ${suggestionCount === 1 ? "suggestion" : "suggestions"}`}
      icon={<ExclamationTriangleIcon data-icon="inline-start" />}
      className={cn(isActive(field.id) ? "bg-yellow-100" : "bg-transparent hover:bg-yellow-50", "text-yellow-600")}
      data-suggestion-indicator={field.id}
      onClick={showSuggestions}
    />
  );
};
